import BaseCollection from './base_collection';
import NewsletterType from './newsletter_type';

// App.Collections.NewsletterTypes
export default BaseCollection.extend({
  model: NewsletterType,

  url: function () {
    return App.Routes.newsletter_types_path();
  }
});
